import { isBrowser as r } from "../../_utils/env/is-browser.js";
let t;
function d() {
  if (!r)
    return !0;
  if (t === void 0) {
    const e = document.createElement("div");
    e.style.display = "flex", e.style.flexDirection = "column", e.style.rowGap = "1px", e.appendChild(document.createElement("div")), e.appendChild(document.createElement("div")), document.body.appendChild(e);
    const n = e.scrollHeight === 1;
    return document.body.removeChild(e), t = n;
  }
  return t;
}
export {
  d as ensureSupportFlexGap
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/space/src/utils.js
// module id = 1695
// module chunks = 41